import {computed} from 'vue'
import {useStorage} from '@vueuse/core'

export interface TogglableFeature {
    isEnabled: Function
}

const features = useStorage<Record<string, boolean>>('features', {})

export const listFeatures = computed(() => {
    return features.value
})

export const getFeatureValue = (key: string, defaultVal = false) => {
    if (!(key in features.value)) {
        features.value[key] = defaultVal
    }

    return features.value[key] || defaultVal
}

export const setFeatureValue = (key: string, value: boolean) => {
    features.value[key] =  value
}

export const clearAllFeatureValues = () => {
    features.value = {}
}

// @ts-ignore
if(window.Cypress) {
    // @ts-ignore
    window.toggleFeatureFlag = setFeatureValue
}
